import updateCurrentBannerAction from '../update-current'
import { BANNER_ID } from '../../constants'

function openErrorBannerAction (data) {
  return updateCurrentBannerAction(BANNER_ID.ERROR, data)
}

export default openErrorBannerAction
